import {useDispatch} from 'react-redux';
import {useCallback} from 'react';
import {favoriteAdd, favoriteRemove} from './actions';
import {ModelActions} from '../model/types';

/**
 * Returns a toggle function that adds or removes a model from favorites.
 * Dispatches an optimistic local update immediately so the UI reflects the
 * change without waiting for a full model-list reload.
 */
export const useToggleFavorite = () => {
  const dispatch = useDispatch();

  return useCallback(
    async (modelUuid: string, currentlyFavorited: boolean) => {
      // Optimistic update — flip the flag in the store right away
      dispatch({type: ModelActions.TOGGLE_FAVORITE, uuid: modelUuid, favorite: !currentlyFavorited});

      try {
        if (currentlyFavorited) {
          await favoriteRemove(dispatch, modelUuid);
        } else {
          await favoriteAdd(dispatch, modelUuid);
        }
      } catch {
        // Revert optimistic update on failure
        dispatch({type: ModelActions.TOGGLE_FAVORITE, uuid: modelUuid, favorite: currentlyFavorited});
      }
    },
    [dispatch],
  );
};
